import Box from "@mui/joy/Box"
import Container from "@mui/joy/Container"
import Stack from "@mui/joy/Stack"
import Typography from "@mui/joy/Typography"
import { RujiraLogo } from "rujira.ui"

export interface LoadingContentProps {
  messages?: string[]
}

const LoadingContent = ({ messages = ["Loading..."] }: LoadingContentProps) => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
        pb: 15,
      }}
    >
      <Stack sx={{ alignItems: "center", rowGap: 2 }}>
        <Box sx={{ width: 150 }}>
          <RujiraLogo animate />
        </Box>

        {messages.map((message, idx) => (
          <Typography
            level="body-sm"
            key={idx}
            sx={{
              fontWeight: 500,
              animation: "fade-dark 1s ease-in infinite alternate",
              "@keyframes fade-dark": {
                "0%": {
                  opacity: "1",
                },
                "40%": {
                  opacity: "1",
                },
                "100%": {
                  opacity: "0.1",
                },
              },
            }}
          >
            {message}
          </Typography>
        ))}
      </Stack>
    </Container>
  )
}

export default LoadingContent
